import script from "./StandingsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StandingsTable.vue?vue&type=script&setup=true&lang=js"

import "./StandingsTable.vue?vue&type=style&index=0&id=4a16fade&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a16fade"]])

export default __exports__